import { createI18n } from 'vue-i18n';
import i18n_es from '@/helpers/i18n/translations/es.json';

export default createI18n({
	legacy: false,
	locale: 'es',
	messages: {
		es: i18n_es
	}
});